var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { GFacade, Singleton } from '@pawgame/game-library';
import { App, EventConsts, FairyRes, Scene, SoundManager } from '@pawgame/laya-game-sdk';
import { loadConfig } from '../../supports/Config';
import { PathDefine } from '../../supports/PathDefine';
import { HomeScene } from '../home/HomeScene';
export class GameOperate {
    static get inst() {
        return Singleton.get(GameOperate);
    }
    init() {
        fgui.UIConfig.packageFileExtension = 'gz';
        fgui.UIConfig.buttonSound = PathDefine.getSound('SFX_ui3');
        Laya.SoundManager.useAudioMusic = false;
        Laya.SoundManager.autoStopMusic = true;
        App.inst.init();
        this.initPanels();
        this.initModels();
    }
    startUp() {
        return __awaiter(this, void 0, void 0, function* () {
            yield loadConfig();
            yield this.loadResource();
            this._isBasicResReady = true;
            this.enterGame();
        });
    }
    loadResource() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield FairyRes.getPackageRes('res/ui/basic').loadAll();
                yield FairyRes.getPackageRes('res/ui/effect').loadAll();
                yield FairyRes.getPackageRes('res/ui/home').loadAll();
            }
            catch (e) {
                console.log('loadResource.fail, retry..');
                yield this.loadResource();
            }
            console.log('load resource complete');
        });
    }
    initPanels() {
    }
    initModels() {
    }
    onLogin() {
        this.enterGame();
    }
    enterGame() {
        if (!this._isBasicResReady) {
            console.log('enterGame.return: basic res not ready');
            return;
        }
        Scene.change(HomeScene);
        GFacade.inst.addListener(EventConsts.STAGE_AWAKEN, this, this.doResume);
        GFacade.inst.addListener(EventConsts.STAGE_SLEEP, this, this.doPause);
    }
    doPause() {
        SoundManager.inst.sysMute = true;
    }
    doResume() {
        SoundManager.inst.sysMute = false;
    }
    get isBasicResReady() {
        return this._isBasicResReady;
    }
}
//# sourceMappingURL=GameOperate.js.map